<template>
    <div>
    
        <div class="row mt-3 mb-2">
                
            <div class="col-md-12">
              <p><b>Curriculum:</b> {{ curriculum.sequenceId }}</p>
                <b-tabs card content-class="mt-2" justified>
                    <b-tab title="Professional Experience" active>
                        <professional-experience :id="id" :user="user" :agency="agency" @reload-curriculum="loadCurriculum" />
                    </b-tab>
                    <b-tab title="Education, Training and Competencies">
                        <education :id="id" :user="user" :agency="agency" @reload-curriculum="loadCurriculum" />
                        <competencie :id="id" :user="user" :agency="agency" @reload-curriculum="loadCurriculum" />
                        <language :id="id" :user="user" :agency="agency" @reload-curriculum="loadCurriculum" />
                    </b-tab>
                    <b-tab title="Relatives and UN information">
                        <relatives :id="id" :user="user" :agency="agency" @reload-curriculum="loadCurriculum" />
                    </b-tab>
                    <b-tab title="Files">
                        <files :id="id" :user="user" :agency="agency" @reload-curriculum="loadCurriculum" />
                    </b-tab>
                    <b-tab v-if="agency.id.toUpperCase() !== 'A170A1C4-71A8-EB11-BEBA-402343F8B2F6'" title="Assessment">
                        <assessment :id="id" :user="user" :agency="agency" @reload-curriculum="loadCurriculum" />
                    </b-tab>
                </b-tabs>
            </div>
        </div>
        <div v-if="curriculum.updatedBy">
            Modified by <b>{{ curriculum.updatedBy.name }} {{ curriculum.updatedBy.surname }}</b> at {{ curriculum.updatedAt | formatDateTime }}.
        </div>
    </div>
</template>

<script>
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'
import axios from 'axios'

import professionalExperience from './professionalExperience'
import education from './education'
import language from './language'
import relatives from './relatives'
import competencie from './competencie'
import files from './files'
import assessment from './assessment'

export default {
    components: { professionalExperience, education, relatives, files, language, competencie, assessment },
    props: {
        user: {
            type: Object,
            required: true,
            default: () => ({}),
        },
        agency: {
            type: Object,
            required: true,
            default: () => ({}),
        },
        id: { type: String, default: () => ({}) }
    },
    data() {
        return {
            activeClass: 'btn btn-success btn-circle2',
            defaultClass: 'btn btn-light btn-circle2',
            nav: 1,
            curriculum: {}
        }
    },
    created() {
        this.loadCurriculum()
    },
    methods: {
        ...authMethods,
        loadCurriculum() {
            axios.get(`${appConfig.apiUrl}curriculum/${this.id}/simple`, { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
                .then((response) => {
                    this.curriculum = response.data
                })
                .catch(error => {
                    this.loginCheck(error.response.status)
                    this.$notify({ group: 'alert', type: 'warn', title: 'Request Error', text: error });
                })
        }
    }
}
</script>